import classNames from 'classnames';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import EfCouponTop, { EfCouponTopProps } from '../ef-coupon-top';
import ExpandArrowBottom from './comps/ExpandArrowBottom';
import { langText } from './comps/langText';
import EfCouponCardModal from './ef-coupon-card-modal';
import './index.scss';
import { injectNotesItem } from './rulesText/injectNotesNew';

interface EfCouponCardProps extends EfCouponTopProps {
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 优惠券
 */
const EfCouponCard: React.FC<EfCouponCardProps> = ({ pc, className, showCouponName, sqlItemData, dataLayer_copy }) => {
    console.log('sqlItemData', sqlItemData);
    const prefixCls = `ef-coupon-card`;
    const { locale = 'us' } = useRouter();
    const TextA = langText[locale] || langText['us'];
    const [isOpen, setIsOpen] = useState(false);
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const pc2 = pc || 'https://websiteoss.ecoflow.com/upload/image/1732497535632/aa1.png';
    const openHandle = () => {
        setIsOpen(true);
    };
    const closeHandle = () => {
        setIsOpen(false);
    };

    const noteList = injectNotesItem(sqlItemData, locale);
    return (
        <>
            <div className={classes}>
                <EfCouponTop pc={pc2} sqlItemData={sqlItemData} showCouponName={showCouponName} dataLayer_copy={dataLayer_copy} />

                <div className={`${prefixCls}-rules`} onClick={openHandle}>
                    <div className={`${prefixCls}-rules-l`}>{TextA.rules}</div>
                    <div className={`${prefixCls}-rules-r`}>
                        <ExpandArrowBottom />
                    </div>
                </div>
            </div>
            {isOpen && (
                <EfCouponCardModal open={isOpen} callback={closeHandle} prefixCls={prefixCls} TextA={TextA} noteList={noteList} sqlItemData={sqlItemData} />
            )}
        </>
    );
};

export default EfCouponCard;
